var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGroupChatBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icGroupChatBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.7939808,8.5750727 C28.2928629,9.06110768 27.8881783,9.65458458 27.6181665,10.329614 C27.5084363,10.6039396 27.4520589,10.8966837 27.4520589,11.1921414 C27.4520589,12.3143511 28.2480017,13.2506583 29.3061499,13.4673257 C29.2302903,13.4764051 29.1537804,13.4809888 29.0770164,13.4809888 L23.3537823,13.4809888 C22.248922,13.4809888 21.3532556,12.5853224 21.3532556,11.4804621 C21.3532556,11.2259562 21.4018188,10.9737879 21.4963399,10.7374851 C22.1591326,9.08050337 23.7639614,7.99398142 25.5485853,7.99398142 L26.5164129,7.99398142 C27.3286771,7.99398142 28.1086075,8.2008878 28.7939808,8.5750727 Z M32.7471084,7.14466047 L33.8706666,7.14466047 C36.0148385,7.14466047 37.9649299,8.38660156 38.871669,10.329614 C39.394449,11.4498569 38.9101097,12.7817901 37.7898668,13.3045701 C37.4934736,13.442887 37.1703687,13.5145676 36.8432899,13.5145676 L30.1991455,13.5145676 C28.916505,13.5145676 27.8767194,12.474782 27.8767194,11.1921414 C27.8767194,10.8966837 27.9330967,10.6039396 28.042827,10.329614 C28.8122679,8.40601178 30.6753253,7.14466047 32.7471084,7.14466047 Z M33.2888715,5.88 C31.6651543,5.88 30.3488715,4.56371716 30.3488715,2.94 C30.3488715,1.31628284 31.6651543,0 33.2888715,0 C34.9125887,0 36.2288715,1.31628284 36.2288715,2.94 C36.2288715,4.56371716 34.9125887,5.88 33.2888715,5.88 Z M26.1488715,6.72 C24.9890735,6.72 24.0488715,5.77979797 24.0488715,4.62 C24.0488715,3.46020203 24.9890735,2.52 26.1488715,2.52 C27.3086695,2.52 28.2488715,3.46020203 28.2488715,4.62 C28.2488715,5.77979797 27.3086695,6.72 26.1488715,6.72 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-expanded-video-copy-13",
    transform: "translate(-104.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(83.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icGroupChatBlack",
    fill: "#111830",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroupChatBlack);
export default __webpack_public_path__ + "static/media/icGroupChatBlack.048025dd47f22d8858b76f4d130a6796.svg";
export { ForwardRef as ReactComponent };